import type { MutableRefObject } from 'react';
import type { CargoRes, ITransportCoordinatesRes, TransportRes, WarehouseRes } from 'api/swagger';
import type { EMapMarkerType } from 'types/map';
import type { TTruckTrailerPairsMap } from 'types/transport';
import type { IDirectionDataService } from 'components/map/map-container/direction-data/types.ts';

export interface IInitMapResult {
  map: google.maps.Map | null;
  mapBoxRef: MutableRefObject<HTMLDivElement | null>;
}

export type IGetMarketsParams = {
  markersRef: MutableRefObject<google.maps.marker.AdvancedMarkerElement[]>;
  polyLinesRef: MutableRefObject<google.maps.Polyline[]>;
};

export interface IUseSetMarkersOptions {
  map: google.maps.Map | null;
  getMarkers: (params: IGetMarketsParams) => void;
  withCluster?: boolean;
}

export interface IUseSetTransportsMarkersOptions extends Pick<IUseSetMarkersOptions, 'map'> {
  transports?: TransportRes[] | ITransportCoordinatesRes[];
  truckTrailerPairs?: TTruckTrailerPairsMap;
}

export interface IUseSetWarehousesMarkersOptions extends Pick<IUseSetMarkersOptions, 'map'> {
  warehouses?: WarehouseRes[];
}

export type THandleClickShowBtn = (id: number) => void;

export interface IUseSetCargosMarkersOptions extends Pick<IUseSetMarkersOptions, 'map'> {
  cargos?: CargoRes[];
  setMode: ESetCargosMarkersMode;
  costView?: boolean;
  handleClickShowBtn?: THandleClickShowBtn;
}

export interface IUseDirectionOptions {
  map: google.maps.Map | null;
  directionDataService?: IDirectionDataService;
}

export enum ESetCargosMarkersMode {
  LOADING = 'loading',
  UNLOADING = 'unloading',
  FULL = 'full',
}

export interface IMapMarkersPayload {
  cargoId: number;
  title: string;
  costValue?: string;
  type: EMapMarkerType;
  realPosition: {
    lat: number;
    lng: number;
  };
  position: {
    lat: number;
    lng: number;
  };

  isChangedPosition: boolean;
}
